import { UserType } from "../../enums/users";
import { format_phone_number } from "../../utils/phone_numbers";

export const passwordValidationError = (
  password: string,
  passwordConfirmation: string
): string | undefined => {
  // Password and confirm password should match
  if (password !== passwordConfirmation) return "Passwords don't match";

  // Password should be non empty
  if (password.length === 0) return "Password can't be empty";

  // Password should not be shorter than 8 characters
  if (password.length < 8)
    return 'Password should contain at least 8 characters';

  return undefined;
};

export function formatAccountId(phone_number:string, usertype: UserType, org_id?: string): string {
  const phone = format_phone_number(phone_number);
  if (!phone) return '';
  const prefix = `${usertype}/${org_id??"".toLowerCase()}`;
  return ['employee', 'merchant', 'driver'].includes(usertype)
    ? `${prefix}/${phone}`
    : phone;
}